import { BEDistributedTransaction } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDistributedTransaction';
import { EnumBEType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';

export class BEDistributedTransactionExtend {
  public static Init(dto: BEDistributedTransaction) {
    dto.bEType = EnumBEType.BEDistributedTransaction;
  }
}
